import { Rule } from 'antd/lib/form';
import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Input } from 'antd';
import { NamePath } from '~/utils/buildNamePath';
import { Form } from '..';

interface Props {
  name: NamePath;
  label?: string;
  disabled?: boolean;
  rules?: Rule[];
  [itemProps: string]: any;
  helpText: string;
  isLine1?: boolean;
}

const CardEmbossingInput: FC<Props> = (props) => {
  const { name, label, disabled, helpText, isLine1, ...itemProps } = props;
  const { t } = useTranslation();

  const rules = [
    { required: true },
    { max: 21 },
    isLine1
      ? {
          pattern: /^[a-zA-Z]+\s+[a-zA-Z]+$/,
          message: 'Please enter exactly two words with alphabetic characters only.',
        }
      : {}, // Regular expression pattern
  ];

  return (
    <Form.Item name={name} shouldUpdate noStyle rules={rules}>
      {(form) => {
        const hasError = (form.getFieldError(name) || []).length > 0;
        return (
          <Form.Item
            rules={rules}
            help={
              hasError ? undefined : (
                <Trans t={t} i18nKey={helpText}>
                  <bdi>{helpText}</bdi>
                </Trans>
              )
            }
            validateStatus={hasError ? 'error' : ''}
            label={label}
            name={name}
            {...itemProps}
          >
            <Input maxLength={21} />
          </Form.Item>
        );
      }}
    </Form.Item>
  );
};

export default CardEmbossingInput;
